'use client'

import { isDateInRange } from 'shared/utils/date'

import { useQueryRewardsProgram } from '../queries/useQueryRewardsProgram'

import InfoFrame from './InfoFrame'

import styles from './RewardsProgramSaleOrdersBanner.module.scss'

const RewardsProgramSaleOrdersBanner = () => {
  const { data: rewardsProgramInfo } = useQueryRewardsProgram()

  const isCampaignEnabled =
    rewardsProgramInfo &&
    Boolean(rewardsProgramInfo?.isEnabled?.booleanField) &&
    isDateInRange(rewardsProgramInfo?.range)

  if (!isCampaignEnabled) return null

  return (
    <InfoFrame
      className={styles.infoFrame}
      range={rewardsProgramInfo?.range}
      frame1Text={rewardsProgramInfo?.frame1}
    />
  )
}

export default RewardsProgramSaleOrdersBanner
